import { isPolygonClockwise as i } from "../geometry-utils/is-polygon-clockwise/index.js";
function s(e) {
  return e = i(e) ? e.slice() : e.slice().reverse(), e;
}
export {
  s as getClockwisePolygon
};
//# sourceMappingURL=index13.js.map
